var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Splash',[_c('div',{staticClass:"logo-holder"},[_c('img',{staticClass:"splash-logo",attrs:{"src":require("@/assets/images/sp-logo-eq-red.png")}}),_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])])])}
var staticRenderFns = []

export { render, staticRenderFns }